import { render } from "./AttachmentsField.vue?vue&type=template&id=141dc2a4&scoped=true"
import script from "./AttachmentsField.vue?vue&type=script&lang=js"
export * from "./AttachmentsField.vue?vue&type=script&lang=js"

import "./AttachmentsField.vue?vue&type=style&index=0&id=141dc2a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141dc2a4"]])

export default __exports__